<template>
  <button class="checked-items-visible-toggle icon" :class="{visible: checkedItemsVisible}" @click="toggleCheckedVisibility">
    <v-icon name="eye"/>
  </button>
</template>
<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'checkedItemsVisibleToggle',
    computed: {
      ...mapState(['checkedItemsVisible'])
    },
    methods: {
      ...mapActions(['toggleCheckedVisibility'])
    },
  }
</script>
<style scoped lang="sass">
  .checked-items-visible-toggle
    min-width: unset
    transition: $transition-quick

    &.visible
      background-color: $blue
      color: $white
      border-color: transparent
</style>
